export default function ProductFeature({ html }) {
    return (
        <>
            <div class="mb-24 pb-24 border-bottom border-gray-100">
                <h5 class="mb-12 fw-bold">Fitur & Desain</h5>
                <div class="text-gray-300 text-15" dangerouslySetInnerHTML={{ __html: html }} />
            </div>

        </>
    );
}
